/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './cycle-day.reducer';

export const CycleDayDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const cycleDayEntity = useAppSelector(state => state.cycleDay.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="cycleDayDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.cycleDay.detail.title">CycleDay</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.cycleDay.id">Id</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.id}</dd>
          <dt>
            <span id="dayType">
              <Translate contentKey="tinyMedicRestApp.cycleDay.dayType">Day Type</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.dayType}</dd>
          <dt>
            <span id="mood">
              <Translate contentKey="tinyMedicRestApp.cycleDay.mood">Mood</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.mood}</dd>
          <dt>
            <span id="moodNotes">
              <Translate contentKey="tinyMedicRestApp.cycleDay.moodNotes">Mood Notes</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.moodNotes}</dd>
          <dt>
            <span id="desireScale">
              <Translate contentKey="tinyMedicRestApp.cycleDay.desireScale">Desire Scale</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.desireScale}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.cycleDay.status">Status</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.status}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.cycleDay.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.cycleDay.active">Active</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.cycleDay.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.cycleDay.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.cycleDay.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.cycleDay.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.cycleDay.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{cycleDayEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.cycleDay.event">Event</Translate>
          </dt>
          <dd>{cycleDayEntity.event ? cycleDayEntity.event.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/cycle-day" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cycle-day/${cycleDayEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CycleDayDetail;
